import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformServer } from '@angular/common';

import { ScriptLoader } from '@spartacus/core';

export enum ScriptPlacement {
  HEAD = 'head',
  BODY = 'body'
}

@Injectable({
  providedIn: 'root'
})
export class CustomScriptLoader extends ScriptLoader {
  constructor(
    @Inject(DOCUMENT) protected document: any,
    @Inject(PLATFORM_ID) protected platformId: any,
  ) {
    super(document, platformId);
  }

  public embedScript(embedOptions: {
    src: string;
    params?: any;
    attributes?: any;
    callback?: EventListener;
    errorCallback?: EventListener;
    placement?: ScriptPlacement;
    asyncLoad?: boolean;
  }): void {
    const {
      src,
      params,
      attributes,
      callback,
      errorCallback,
      placement = ScriptPlacement.HEAD,
      asyncLoad = true
    } = embedOptions;

    const isSSR = isPlatformServer(this.platformId);
    if ((callback || errorCallback) && isSSR) {
      return;
    }

    const source = params ? src + this.customParseParams(params) : src;
    if (!isSSR && this.hasScript(source)) {
      return;
    }

    const script: HTMLScriptElement = this.document.createElement('script');
    script.src = source;
    script.async = asyncLoad;
    script.defer = asyncLoad;

    if (attributes) {
      Object.keys(attributes).forEach((key) => {
        if (key.startsWith('data-')) {
          script.setAttribute(key, attributes[key]);
        } else {
          script[key] = attributes[key];
        }
      });
    }

    if (callback) {
      script.addEventListener('load', callback);
    }
    if (errorCallback) {
      script.addEventListener('error', errorCallback);
    }

    if (placement === ScriptPlacement.HEAD) {
      this.document.head.appendChild(script);
    } else {
      this.document.body.appendChild(script);
    }
  }

  private customParseParams(params: object): string {
    let result = '';
    const keysArray = Object.keys(params);
    if (keysArray.length > 0) {
      result =
        '?' +
        keysArray
          .map((key) => encodeURI(key) + '=' + encodeURI(params[key]))
          .join('&');
    }
    return result;
  }
}
